import React from 'react';
import type { FieldProps } from './Field';

interface TextFieldProps extends FieldProps<string> {
  placeholder?: string;
  type: TextType;
}

export enum TextType {
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  TEL = 'tel',
}

const TextField: React.FC<TextFieldProps> = ({ 
    label, 
    placeholder, 
    value,
    onChange
  }) => {
    return (
      <div style={{ marginBottom: '1rem' }}>
        {label && <label style={{ display: 'block', marginBottom: '0.25rem' }}>{label}</label>}
        <input
          type='text'
          value={value}
          placeholder={placeholder}
          style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    );
  };
  
export default TextField;